
export const TIME_SLOTS_CONFIG = {
  START_HOUR: 11, // 11 AM
  END_HOUR: 21,  // 9 PM
} as const;
